module.exports = "/assets/data/be8eadecb0c990aacf7c22c98b863d14-SG13.data.json";